var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-items-center warp"},[_c('span',{staticClass:"title"},[_vm._v("设备分类：")]),_c('TReeBlock',{ref:"deviceType",attrs:{"keyVal":"deviceType","options":_vm.BranchList,"width":"180","childKey":"children"},on:{"getVal":_vm.getVal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }